import { FeedList } from "./FeedList";

export default FeedList;
